import React from 'react'

import HARDCODE from '../../../business-const/HardCode/HardCode'

import LABEL from '../../../business-const/Label/Label'

import {
    gerarArraySerieBarArea,
} from '../../../business-components/Array/Array'

import {
    formataEstudoHipotesesRetorno,
} from '../../../business-components/Formata/Formata'

import {
    GridContainer,
    GridItem11,
    GridItem12,
} from '../../../business-components/Grid/Grid'

import {
    ChartPadrao
} from '../../../business-components/Chart/Chart'

import {
    relatorioModoApresentacao,
} from '../estudo-form/EstudoService'

import {
    processaValoresDefaultIniciaisHipotesesRetornoRealProjetoVidaSonhoTracarMetaChart
} from './HipotesesRetornoRealProjetoVidaSonhoTracarMetaChartService'

import {
    CardGridEstudoPadraoMd,
} from '../estudo-form/EstudoComp'



const HipotesesRetornoRealChart = ( { values, handleSubmitAutomatico, estudo, report, jsonConfiguracao } ) => {

    const HipotesesRetornoReal = ( props ) => {

        processaValoresDefaultIniciaisHipotesesRetornoRealProjetoVidaSonhoTracarMetaChart(values,
            handleSubmitAutomatico, estudo, report, jsonConfiguracao, LABEL.aposentadoria)
    
        const series = gerarArraySerieBarArea(LABEL.aporteMensal, estudo.current.graficoHipotesesRetornoReal)
    
        const categories = estudo.current.percHipotesesRetornoRealProjetoVidaSonhoTracarMetaList
    
        const GridGrafico = report ? GridItem11 : GridItem11
 
        return (

            <div
                {...props}
            >
                <GridContainer>
                    <GridGrafico>
                        <ChartPadrao
                            titleText={''} // mudança da fonte: titleText={LABEL.hipotesesRetornoReal + ': ' + LABEL.aposentadoria}
                            type="area"
                            distributed={true}
                            series={series}
                            stacked={true}
                            categories={categories}
                            paletaCores={estudo.current.coresHipotesesRetornoRealProjetoVidaSonhoTracarMetaList}
                            columnWidth='70%'
                            toolTipX={false}
                            toolTipXTotal={false}
                            report={report}
                            formatoReport={values.formatoReport}
                            fillOpacity={0.8}
                            dataLabelsEnabled={true}
                            dataLabelsEnabledReport={true}
                            dataLabelsType="Large"
                            xaxisType="Large"
                            notLegendShow={true}
                        />
                    </GridGrafico>
                </GridContainer>
            </div>
        )
    }

    return (
        <GridItem12>
            {report
                ?
                    <HipotesesRetornoReal
                        className='mt--5 ml-5' // mudança da fonte: mt-10
                    />
                :
                    <CardGridEstudoPadraoMd
                        label={
                            !relatorioModoApresentacao(values)
                                ?
                                    formataEstudoHipotesesRetorno(LABEL.hipotesesRetornoReal, LABEL.aposentadoria)
                                :
                                    HARDCODE.modoApresentacaoRelatorio
                        }
                        component={
                            <HipotesesRetornoReal/>
                        }
                        overflowX={false}
                        modoApresentacao={values.modoApresentacao}
                    />
            }
        </GridItem12>
    )
}

export default HipotesesRetornoRealChart